import { useState } from 'react'
import { TextField, Button, MenuItem, Alert } from '@mui/material'
import { motion } from 'framer-motion'
import { colors, textFieldSx } from '../styles/theme'

const Form = ({ type = 'contact' }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    type: 'Listener',
    message: '',
  })
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }))
    }
  }

  const validate = () => {
    const newErrors = {}
    if (!formData.name.trim()) newErrors.name = 'Name is required'
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email format'
    }
    if (type === 'contact' && !formData.message.trim()) {
      newErrors.message = 'Message is required'
    }
    return newErrors
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrors = validate()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    console.log('Form submitted:', formData)
    setSubmitted(true)

    setTimeout(() => {
      setFormData({ name: '', email: '', type: 'Listener', message: '' })
      setSubmitted(false)
    }, 3000)
  }

  if (submitted) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <Alert
          severity="success"
          sx={{
            backgroundColor: 'rgba(var(--color-accent-primary-rgb), 0.1)',
            color: colors.accent,
            border: `1px solid ${colors.accent}`,
            boxShadow: 'var(--shadow-accent-glow)',
            fontFamily: 'JetBrains Mono, monospace',
          }}
        >
          {type === 'contact'
            ? 'Thank you for reaching out! We\'ll get back to you soon.'
            : 'Thank you for subscribing to our newsletter!'}
        </Alert>
      </motion.div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <TextField
        fullWidth label="Name" name="name"
        value={formData.name} onChange={handleChange}
        error={!!errors.name} helperText={errors.name} required
        sx={textFieldSx}
      />

      <TextField
        fullWidth label="Email" name="email" type="email"
        value={formData.email} onChange={handleChange}
        error={!!errors.email} helperText={errors.email} required
        sx={textFieldSx}
      />

      {type === 'contact' && (
        <>
          <TextField
            fullWidth select label="I am a..." name="type"
            value={formData.type} onChange={handleChange}
            sx={textFieldSx}
          >
            <MenuItem value="Listener">Listener</MenuItem>
            <MenuItem value="Guest">Potential Guest</MenuItem>
            <MenuItem value="Sponsor">Sponsor</MenuItem>
          </TextField>

          <TextField
            fullWidth label="Message" name="message"
            value={formData.message} onChange={handleChange}
            error={!!errors.message} helperText={errors.message}
            multiline rows={5} required
            sx={textFieldSx}
          />
        </>
      )}

      <Button
        type="submit" variant="contained" fullWidth size="large"
        sx={{
          backgroundColor: colors.accent,
          color: colors.textOnAccent,
          fontWeight: 700,
          fontFamily: 'JetBrains Mono, monospace',
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          py: 1.5,
          boxShadow: 'var(--shadow-accent-glow)',
          '&:hover': {
            backgroundColor: colors.accentHover,
            boxShadow: 'var(--shadow-accent-glow-lg)',
          },
        }}
      >
        {type === 'contact' ? 'Send Message' : 'Subscribe'}
      </Button>
    </form>
  )
}

export default Form
